/**
 * NEC + CEC code reference panel for the Small Power tab.
 * Pure presentational — toggled by parent.
 */
export default function CodeRefsPanel() {
  return (
    <div className="border border-cyan-500/30 bg-cyan-500/5 p-4 text-sm text-cyan-100 font-mono mb-4" data-testid="small-power-info-panel">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="text-[#00E5FF] font-bold mb-2">NEC (2023)</div>
          <ul className="list-disc pl-5 space-y-1 text-xs">
            <li><b>210.52 / 210.63</b> — perimeter & service receptacles within 25 ft of electrical/HVAC equipment.</li>
            <li><b>110.26(D)</b> — illumination required in working spaces about equipment.</li>
            <li><b>210.70(C)</b> — lighting outlet + switch at point of entry.</li>
            <li><b>IES RP-7</b> — 30–50 fc maintained at the floor.</li>
            <li><b>700.16</b> — emergency illumination requirements.</li>
          </ul>
        </div>
        <div>
          <div className="text-[#00E5FF] font-bold mb-2">CEC (25th ed)</div>
          <ul className="list-disc pl-5 space-y-1 text-xs">
            <li><b>Rule 26-712</b> — perimeter receptacle spacing ≤ 3.7 m (≈ 12 ft).</li>
            <li><b>Rule 26-714</b> — service rooms require a 15 A or 20 A duplex receptacle on a separate circuit.</li>
            <li><b>Rule 30-300</b> — permanent lighting + switch near the door in every service room.</li>
            <li><b>Rule 46-302</b> — emergency lighting in service rooms.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
